import { combineReducers } from 'redux';
import appProps from './app-props';
import persisted from './persisted';
import ui from './ui';

const combinedReducer = combineReducers({ appProps, persisted, ui });
export default combinedReducer;
